import { useStaffAuth } from '@/contexts/StaffAuthContext';
import { Navigate } from 'react-router-dom';

export function ProtectedStaffRoute({ children, roles }) {
  const { staff, loading } = useStaffAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-muted-ink">Loading…</div>;
  if (!staff) return <Navigate to="/staff/login" replace />;
  if (roles && !roles.includes(staff.role)) {
    return (
      <div className="min-h-screen flex items-center justify-center text-charcoal">
        You don't have permission to view this page.
      </div>
    );
  }
  return children;
}
